import { useCallback, useRef, useState } from 'react'
import { Configure, Index, useSearchBox } from 'react-instantsearch'
import { SearchResults as SearchResultsComponent } from '@sh24/ui-components'
import SearchHits from './search-hits'
import useTranslations from '../../utils/use-translations'
import useCloseKeyboardOnScroll from '../../hooks/use-close-keyboard-on-scroll'
import getResultCount from './get-result-count'

const SearchResults = ({ rounded, indexes }) => {
  const translations = useTranslations()
  const { query } = useSearchBox()
  const [counts, setCounts] = useState({})
  const hasQuery = query.trim().length > 2
  const totalHits = Object.values(counts).reduce((sum, c) => sum + c, 0)
  const panelRef = useRef(null)

  const updateCount = useCallback(
    (indexName, count) => {
      setCounts((prev) => ({ ...prev, [indexName]: count }))
    },
    [setCounts],
  )

  useCloseKeyboardOnScroll(panelRef)

  return (
    <SearchResultsComponent
      ref={panelRef}
      rounded={rounded}
      active={hasQuery}
      resultCount={getResultCount(totalHits, translations)}
    >
      {indexes?.map((indexName) => (
        <Index key={indexName} indexName={indexName}>
          <Configure hitsPerPage={6} />
          <SearchHits indexName={indexName} updateCount={updateCount} />
        </Index>
      ))}
    </SearchResultsComponent>
  )
}

export default SearchResults
